import { useState } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { Announcement } from '../../components/Dashboard/homepage/Announcement'
import { useGetAnnouncementQuery } from '../../features/strapi/strapiSlice'
import { Loader } from '../../shared/Loader'

export const Announcements = () => {
  const [page, setPage] = useState<number>(1)
  const { data: announcements, isLoading } = useGetAnnouncementQuery({
    page,
    pageSize: 5,
  })
  return (
    <div className='font-dashboard pt-8 pb-24 lg:px-4'>
      <div className='bg-black px-4 lg:px-10 py-10'>
        <div className='max-w-[765px] mx-auto'>
          <h1 className='text-3xl font-semibold text-primary text-center'>
            Announcements
          </h1>

          <div className='w-full h-auto flex flex-col gap-4 mt-12'>
            {isLoading ? (
              <div className='flex justify-center items-center'>
                <Loader />
              </div>
            ) : (
              announcements?.data.map((announcement: any) => (
                <Announcement
                  title={announcement?.attributes.title}
                  description={announcement?.attributes.description}
                  publishedAt={announcement?.attributes.publishedAt}
                />
              ))
            )}

            <div className='flex items-center gap-5 mt-12'>
              <p className='text-white/60 font-light text-sm'>
                page: {page} | total: {announcements?.meta.pagination.total}{' '}
                announcements
              </p>
              <div className='flex items-center gap-2'>
                <button
                  className='rounded-full bg-gray-500 hover:bg-gray-600 text-white/70 disabled:cursor-not-allowed disabled:bg-gray-500/50 disabled:text-white/20 text-lg cursor-pointer'
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                >
                  <FiChevronLeft className='box-content p-3' />
                </button>

                <button
                  className='rounded-full bg-gray-500 hover:bg-gray-600 text-white/70 disabled:cursor-not-allowed disabled:bg-gray-500/50 disabled:text-white/20 text-lg cursor-pointer'
                  disabled={page == announcements?.meta.pagination?.pageCount}
                  onClick={() => setPage(page + 1)}
                >
                  <FiChevronRight className='box-content p-3' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
